import { inject, Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';
import { suggestedSearchesConst } from '../constants/suggested-searches.const';
import { Store, StoresApiService } from '@client-monorepo/daily-fintech/stores';

@Injectable({
  providedIn: 'root',
})
export class StoreService {
  storeApiService = inject(StoresApiService);

  getSugestedSearches(): Observable<Array<string>> {
    return of(suggestedSearchesConst).pipe(delay(200));
  }

  getPopularStores(page = 0, size = 10): Observable<Array<Store>> {
    return this.storeApiService.getPopularStores(page, size);
  }
}
